var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.id)?_c('Dashboard',{attrs:{"item":_vm.item,"type":"project"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HeaderComponent',{attrs:{"title":_vm.$i18n.t('analytics'),"breadcrumb":_vm.breadcrumbs}})]},proxy:true}],null,false,1670716873)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }